<template>
  <div class="pairing-service-text">
    <span v-if="!services.length">-</span>
    <span v-for="(service, index) in services" :key="`${service.type}:${service.id}`">
      <span class="service">
        {{ service.name }}
        <Tag v-if="!service.isPublic" type="warning" size="mini">已下架</Tag>
      </span>
      <span v-if="index < services.length - 1">、</span>
    </span>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import Tag from '@/components/Tag/Tag.vue'

// 列表欄位：主要服務、搭配服務的名稱；下架的服務標示「已下架」
export default defineComponent({
  name: 'PairingServiceText',
  components: { Tag },
  props: {
    services: { type: Array, default: () => [] },
  },
})
</script>

<style lang="postcss" scoped>
.pairing-service-text {
  @apply break-words;
}
.service {
  @apply inline-flex items-center gap-[4px];
}
</style>
